import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Accordion,
	AccordionSummary,
	AccordionDetails
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import {
	resetGetVoucherTransactionDetails,
	getVoucherTransactionDetailsList
} from "../../redux/actions/getVoucherTransactionDetailsListAction";
import { makeStyles } from "@mui/styles";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const GetVoucherTransactionDetails = () => {
	const classes = useStyles();
	const location = useLocation();
	const trackingId = location.search.split("?userId=")[1];
	// console.log(trackingId);

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const [
		getVoucherTransactionDetailsStatus,
		SetgetVoucherTransactionDetailsStatus
	] = useState(false);

	const [
		getVoucherTransactionDetailsArray,
		SetgetVoucherTransactionDetailsArray
	] = useState([]);

	const getVoucherTransactionDetailsRes = useSelector(
		({ getVoucherTransactionDetails }) => getVoucherTransactionDetails
	);

	// useEffect(() => {
	//   SetgetVoucherTransactionDetailsStatus(true);
	//   const getVoucherTransactionDetailsReq = {
	//     loginDetails: {
	//       walletOwnerId: "1",
	//     },
	//     voucherTransVO: {
	//       trackingId: trackingId,
	//     },
	//   };

	//   return dispatch(
	//     getVoucherTransactionDetailsList(
	//       getVoucherTransactionDetailsReq,
	//       authToken
	//     )
	//   );
	// }, []);

	const getVoucherTransactionDetailsReqApi = () => {
		SetgetVoucherTransactionDetailsStatus(true);
		const getVoucherTransactionDetailsReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			voucherTransVO: {
				trackingId: trackingId
			}
		};

		return dispatch(
			getVoucherTransactionDetailsList(
				getVoucherTransactionDetailsReq,
				regenerateTokenRes.data.AuthToken
			)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getVoucherTransactionDetailsReqApi();
		}
	}, [regenerateTokenRes.data.status]);

	useEffect(() => {
		if (getVoucherTransactionDetailsStatus) {
			if (getVoucherTransactionDetailsRes.data.status == "success") {
				SetgetVoucherTransactionDetailsArray(
					getVoucherTransactionDetailsRes.data.voucherTransVO
				);
			}
			if (getVoucherTransactionDetailsRes.data.status == "Failed") {
				SetgetVoucherTransactionDetailsArray(
					getVoucherTransactionDetailsRes.data
				);
				if (
					getVoucherTransactionDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
        if (
					getVoucherTransactionDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherTransactionDetailsRes.data.status == "failed") {
				SetgetVoucherTransactionDetailsArray(
					getVoucherTransactionDetailsRes.data
				);
				if (
					getVoucherTransactionDetailsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
        if (
					getVoucherTransactionDetailsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherTransactionDetailsRes.data.status == "NOT FOUND") {
				SetgetVoucherTransactionDetailsArray(
					getVoucherTransactionDetailsRes.data
				);
			}
		}
	}, [getVoucherTransactionDetailsRes.data.status]);

	return (
		<>
			<Layout>
				<BackButton />
				<div
					style={{
						background: "white",
						paddingBottom: "1rem",
						paddingTop: "0.5rem"
					}}
				>
					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						{getVoucherTransactionDetailsArray &&
						getVoucherTransactionDetailsArray ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography className="themeText">
											Customer Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<>
											<TableContainer component={Paper}>
												{getVoucherTransactionDetailsArray &&
													getVoucherTransactionDetailsArray && (
														<Table
															className={classes.table}
															aria-label="a dense table"
															style={{ whiteSpace: "nowrap" }}
														>
															<TableHead>
																<TableRow className="tableHeaderColor">
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Customer Id{" "}
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Customer Name
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Country Code
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Customer Email
																	</TableCell>
																</TableRow>
															</TableHead>

															<TableBody>
																{getVoucherTransactionDetailsArray &&
																	[]
																		.concat(getVoucherTransactionDetailsArray)
																		.map((row, index) => (
																			<TableRow key={index}>
																				<TableCell align="center">
																					{row.customerId
																						? row.customerId
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.contactName
																						? row.contactName
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.country ? row.country : "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.email ? row.email : "-"}
																				</TableCell>
																			</TableRow>
																		))}
															</TableBody>
														</Table>
													)}
											</TableContainer>
										</>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{/* {getVoucherTransactionDetailsArray &&
          getVoucherTransactionDetailsArray.customerDetailsVO ?
          (
            <>
              <TableContainer component={Paper}>
                <BackButton />
                <Typography
                  variant="body1"
                  style={{
                    textAlign: "center",
                    margin: "10px 0",
                    color: "#01367e",
                    fontSize: "1.4rem",
                  }}
                >
                  Customer Details
                </Typography>

                {getVoucherTransactionDetailsArray &&
                  getVoucherTransactionDetailsArray.customerDetailsVO && (
                    <Table
                      className={classes.table}
                      aria-label="a dense table"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <TableHead>
                        <TableRow style={{ background: "#00b9f5" }}>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Customer Id{" "}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Customer Name
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Country Code
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontWeight: "bold", color: "white" }}
                          >
                            Customer Email
                          </TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {getVoucherTransactionDetailsArray.customerDetailsVO &&
                          []
                            .concat(
                              getVoucherTransactionDetailsArray.customerDetailsVO
                            )
                            .map((row, index) => (
                              <TableRow key={row.walletId}>
                                <TableCell align="center">{row.customerId}</TableCell>
                                <TableCell align="center">
                                  {row.contactName}
                                </TableCell>
                                <TableCell align="center">{row.country}</TableCell>
                                <TableCell align="center">{row.email}</TableCell>
                              </TableRow>
                            ))}
                      </TableBody>
                    </Table>
                  )}
              </TableContainer>
            </>)
          :
          ("")
        } */}

						{/* <TableContainer component={Paper}>
          <BackButton />
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            Customer Details
          </Typography>

          {getVoucherTransactionDetailsArray &&
            getVoucherTransactionDetailsArray.customerDetailsVO && (
              <Table
                className={classes.table}
                aria-label="a dense table"
                style={{ whiteSpace: "nowrap" }}
              >
                <TableHead>
                  <TableRow style={{ background: "#00b9f5" }}>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Customer Id{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Customer Name
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Country Code
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Customer Email
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getVoucherTransactionDetailsArray.customerDetailsVO &&
                    []
                      .concat(
                        getVoucherTransactionDetailsArray.customerDetailsVO
                      )
                      .map((row, index) => (
                        <TableRow key={row.walletId}>
                          <TableCell align="center">{row.customerId}</TableCell>
                          <TableCell align="center">
                            {row.contactName}
                          </TableCell>
                          <TableCell align="center">{row.country}</TableCell>
                          <TableCell align="center">{row.email}</TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            )}
        </TableContainer> */}

						{getVoucherTransactionDetailsArray &&
						getVoucherTransactionDetailsArray ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography className="themeText">
											Transaction Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<>
											<TableContainer component={Paper}>
												{getVoucherTransactionDetailsArray &&
													getVoucherTransactionDetailsArray && (
														<Table
															className={classes.table}
															aria-label="a dense table"
															style={{ whiteSpace: "nowrap" }}
														>
															<TableHead>
																<TableRow className="tableHeaderColor">
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Tracking Id{" "}
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Payment Id
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Order Description
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Purchase Amount
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Refund Amount{" "}
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Currency
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Status
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Date
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		First Six{" "}
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Last Four
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Rule Triggered
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Reason
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	></TableCell>
																</TableRow>
															</TableHead>

															<TableBody>
																{getVoucherTransactionDetailsArray &&
																	[]
																		.concat(getVoucherTransactionDetailsArray)
																		.map((row, index) => (
																			<TableRow key={row.index}>
																				<TableCell align="center">
																					{row.trackingId
																						? row.trackingId
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{"-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.orderDescription
																						? row.orderDescription
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.voucherAmount
																						? row.voucherAmount
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.refundAmount
																						? row.refundAmount
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.voucherCurrency
																						? row.voucherCurrency
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.status ? row.status : "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.timestamp ? row.timestamp : "-"}
																				</TableCell>
																				<TableCell align="center">-</TableCell>
																				<TableCell align="center">-</TableCell>
																				<TableCell align="center">-</TableCell>
																				<TableCell align="center">-</TableCell>
																			</TableRow>
																		))}
															</TableBody>
														</Table>
													)}
											</TableContainer>
										</>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{/* {getVoucherTransactionDetailsArray &&
              getVoucherTransactionDetailsArray ?
              (
                <>
                  <TableContainer component={Paper} style={{ marginTop: "15px" }}>
                    <Typography
                      variant="body1"
                      style={{
                        textAlign: "center",
                        margin: "10px 0",
                        color: "#01367e",
                        fontSize: "1.4rem",
                      }}
                    >
                      Transaction Details
                    </Typography>

                    {getVoucherTransactionDetailsArray &&
                      getVoucherTransactionDetailsArray && (
                        <Table
                          className={classes.table}
                          aria-label="a dense table"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          <TableHead>
                            <TableRow style={{ background: "#00b9f5" }}>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Tracking Id{" "}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Payment Id
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Order Description
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Purchase Amount
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Refund Amount{" "}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Currency
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Status
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Date
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                First Six{" "}
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Last Four
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Rule Triggered
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              >
                                Reason
                              </TableCell>
                              <TableCell
                                align="center"
                                style={{ fontWeight: "bold", color: "white" }}
                              ></TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {getVoucherTransactionDetailsArray &&
                              []
                                .concat(getVoucherTransactionDetailsArray)
                                .map((row, index) => (
                                  <TableRow key={row.trackingId}>
                                    <TableCell align="center">{row.trackingId}</TableCell>
                                    <TableCell align="center">{row.trackingId}</TableCell>
                                    <TableCell align="center">
                                      {row.orderDescription}
                                    </TableCell>
                                    <TableCell align="center">{row.voucherAmount}</TableCell>
                                    <TableCell align="center">
                                      {row.refundAmount}
                                    </TableCell>
                                    <TableCell align="center">
                                      {row.voucherCurrency}
                                    </TableCell>
                                    <TableCell align="center">{row.status}</TableCell>
                                    <TableCell align="center">{row.timestamp}</TableCell>
                                    <TableCell align="center">-</TableCell>
                                    <TableCell align="center">-</TableCell>
                                    <TableCell align="center">-</TableCell>
                                    <TableCell align="center">-</TableCell>
                                  </TableRow>
                                ))}
                          </TableBody>
                        </Table>
                      )}
                  </TableContainer>
                </>)
              :
              ("")
            } */}

						{/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            Transaction Details
          </Typography>

          {getVoucherTransactionDetailsArray &&
            getVoucherTransactionDetailsArray && (
              <Table
                className={classes.table}
                aria-label="a dense table"
                style={{ whiteSpace: "nowrap" }}
              >
                <TableHead>
                  <TableRow style={{ background: "#00b9f5" }}>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Tracking Id{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Payment Id
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Order Description
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Purchase Amount
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Refund Amount{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Currency
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Status
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Date
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      First Six{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Last Four
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Rule Triggered
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Reason
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    ></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getVoucherTransactionDetailsArray &&
                    []
                      .concat(getVoucherTransactionDetailsArray)
                      .map((row, index) => (
                        <TableRow key={row.trackingId}>
                          <TableCell align="center">{row.trackingId}</TableCell>
                          <TableCell align="center">{row.trackingId}</TableCell>
                          <TableCell align="center">
                            {row.orderDescription}
                          </TableCell>
                          <TableCell align="center"></TableCell>
                          <TableCell align="center">
                            {row.refundAmount}
                          </TableCell>
                          <TableCell align="center">
                            {row.voucherCurrency}
                          </TableCell>
                          <TableCell align="center">{row.status}</TableCell>
                          <TableCell align="center">{row.timestamp}</TableCell>
                          <TableCell align="center">-</TableCell>
                          <TableCell align="center">-</TableCell>
                          <TableCell align="center">-</TableCell>
                          <TableCell align="center">-</TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            )}
        </TableContainer> */}

						{getVoucherTransactionDetailsArray &&
						getVoucherTransactionDetailsArray.voucherListRequestVOList ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography className="themeText">
											Voucher Details
										</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<>
											<TableContainer component={Paper}>
												{getVoucherTransactionDetailsArray &&
													getVoucherTransactionDetailsArray.customerDetailsVO && (
														<Table
															className={classes.table}
															aria-label="a dense table"
															style={{ whiteSpace: "nowrap" }}
														>
															<TableHead>
																<TableRow className="tableHeaderColor">
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Voucher Id{" "}
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Voucher Number
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Voucher Type
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Voucher Status
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Voucher Amount
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Voucher Currency
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Creation Date
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Activation Date
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Redeem Date
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Expiry Date
																	</TableCell>
																</TableRow>
															</TableHead>

															<TableBody>
																{getVoucherTransactionDetailsArray.voucherListRequestVOList &&
																	[]
																		.concat(
																			getVoucherTransactionDetailsArray.voucherListRequestVOList
																		)
																		.map((row, index) => (
																			<TableRow key={row.index}>
																				<TableCell align="center">
																					{row.voucherId ? row.voucherId : "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.voucherNumber
																						? row.voucherNumber
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.voucherType
																						? row.voucherType
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.voucherType.status
																						? row.voucherType.status
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.amount ? row.amount : "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.currency ? row.currency : "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.creationDate
																						? row.creationDate
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.activationDate
																						? row.activationDate
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.redeemDate
																						? row.redeemDate
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.expiryDate
																						? row.expiryDate
																						: "-"}
																				</TableCell>
																			</TableRow>
																		))}
															</TableBody>
														</Table>
													)}
											</TableContainer>
										</>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{/* {getVoucherTransactionDetailsArray &&
              getVoucherTransactionDetailsArray.voucherListRequestVOList ?
              (
              <>
                <TableContainer component={Paper} style={{ marginTop: "15px" }}>
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "center",
                      margin: "10px 0",
                      color: "#01367e",
                      fontSize: "1.4rem",
                    }}
                  >
                    Voucher Details
                  </Typography>

                  {getVoucherTransactionDetailsArray &&
                    getVoucherTransactionDetailsArray.customerDetailsVO && (
                      <Table
                        className={classes.table}
                        aria-label="a dense table"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <TableHead>
                          <TableRow style={{ background: "#00b9f5" }}>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Id{" "}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Number
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Type
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Status
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Amount
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Voucher Currency
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Creation Date
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Activation Date
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Redeem Date
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Expiry Date
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {getVoucherTransactionDetailsArray.voucherListRequestVOList &&
                            []
                              .concat(
                                getVoucherTransactionDetailsArray.voucherListRequestVOList
                              )
                              .map((row, index) => (
                                <TableRow key={row.walletId}>
                                  <TableCell align="center">{row.voucherId ? row.voucherId : "-"}</TableCell>
                                  <TableCell align="center">
                                    {row.voucherNumber ? row.voucherNumber : "-"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.voucherType}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.voucherType.status}
                                  </TableCell>
                                  <TableCell align="center">{row.amount}</TableCell>
                                  <TableCell align="center">{row.currency}</TableCell>
                                  <TableCell align="center">
                                    {row.creationDate}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.activationDate}
                                  </TableCell>
                                  <TableCell align="center">{row.redeemDate}</TableCell>
                                  <TableCell align="center">{row.expiryDate}</TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    )}
                </TableContainer>
              </>)
              :
              ("")} */}

						{/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            Voucher Details
          </Typography>

          {getVoucherTransactionDetailsArray &&
            getVoucherTransactionDetailsArray.customerDetailsVO && (
              <Table
                className={classes.table}
                aria-label="a dense table"
                style={{ whiteSpace: "nowrap" }}
              >
                <TableHead>
                  <TableRow style={{ background: "#00b9f5" }}>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Voucher Id{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Voucher Number
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Voucher Type
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Voucher Status
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Voucher Amount
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Voucher Currency
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Creation Date
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Activation Date
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Redeem Date
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Expiry Date
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getVoucherTransactionDetailsArray.voucherListRequestVOList &&
                    []
                      .concat(
                        getVoucherTransactionDetailsArray.voucherListRequestVOList
                      )
                      .map((row, index) => (
                        <TableRow key={row.walletId}>
                          <TableCell align="center">{row.voucherId}</TableCell>
                          <TableCell align="center">
                            {row.voucherNumber}
                          </TableCell>
                          <TableCell align="center">
                            {row.voucherType}
                          </TableCell>
                          <TableCell align="center">
                            {row.voucherType.status}
                          </TableCell>
                          <TableCell align="center">{row.amount}</TableCell>
                          <TableCell align="center">{row.currency}</TableCell>
                          <TableCell align="center">
                            {row.creationDate}
                          </TableCell>
                          <TableCell align="center">
                            {row.activationDate}
                          </TableCell>
                          <TableCell align="center">{row.redeemDate}</TableCell>
                          <TableCell align="center">{row.expiryDate}</TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            )}
        </TableContainer> */}

						{getVoucherTransactionDetailsArray &&
						getVoucherTransactionDetailsArray.voucherHistoryVoList ? (
							<div
								style={{
									marginTop: "2rem"
								}}
							>
								<Accordion>
									<AccordionSummary
										expandIcon={<ExpandMore />}
										aria-controls="panel1a-content"
										id="panel1a-header"
									>
										<Typography className="themeText">History</Typography>
									</AccordionSummary>
									<AccordionDetails style={{ display: "unset" }}>
										<>
											<TableContainer component={Paper}>
												{getVoucherTransactionDetailsArray &&
													getVoucherTransactionDetailsArray.voucherHistoryVoList && (
														<Table
															className={classes.table}
															aria-label="a dense table"
															style={{ whiteSpace: "nowrap" }}
														>
															<TableHead>
																<TableRow className="tableHeaderColor">
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Action
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		TimeStamp
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Purchase Amount
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Refund Amount
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Currency
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Remark{" "}
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Response Transaction ID
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Action Executor Name
																	</TableCell>
																	<TableCell
																		align="center"
																		style={{
																			fontWeight: "bold",
																			color: "white"
																		}}
																	>
																		Reason
																	</TableCell>
																</TableRow>
															</TableHead>

															<TableBody>
																{getVoucherTransactionDetailsArray.voucherHistoryVoList &&
																	[]
																		.concat(
																			getVoucherTransactionDetailsArray.voucherHistoryVoList
																		)
																		.map((row, index) => (
																			<TableRow key={row.index}>
																				<TableCell align="center">-</TableCell>
																				<TableCell align="center">
																					{row.timeStamp ? row.timeStamp : "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.purchaseAmount
																						? row.purchaseAmount
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.refundAmount
																						? row.refundAmount
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.purchaseCurrency
																						? row.purchaseCurrency
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.remark ? row.remark : "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.responseTransactionId
																						? row.responseTransactionId
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.actionExecutorName
																						? row.actionExecutorName
																						: "-"}
																				</TableCell>
																				<TableCell align="center">
																					{row.reason ? row.reason : "-"}
																				</TableCell>
																			</TableRow>
																		))}
															</TableBody>
														</Table>
													)}
											</TableContainer>
										</>
									</AccordionDetails>
								</Accordion>
							</div>
						) : (
							""
						)}

						{/* {getVoucherTransactionDetailsArray &&
              getVoucherTransactionDetailsArray.voucherHistoryVoList ?
              (
              <>
                <TableContainer component={Paper} style={{ marginTop: "15px" }}>
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "center",
                      margin: "10px 0",
                      color: "#01367e",
                      fontSize: "1.4rem",
                    }}
                  >
                    History
                  </Typography>

                  {getVoucherTransactionDetailsArray &&
                    getVoucherTransactionDetailsArray.voucherHistoryVoList && (
                      <Table
                        className={classes.table}
                        aria-label="a dense table"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <TableHead>
                          <TableRow style={{ background: "#00b9f5" }}>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Action
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              TimeStamp
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Purchase Amount
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Refund Amount
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Currency
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Remark{" "}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Response Transaction ID
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Action Executor Name
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ fontWeight: "bold", color: "white" }}
                            >
                              Reason
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {getVoucherTransactionDetailsArray.voucherHistoryVoList &&
                            []
                              .concat(
                                getVoucherTransactionDetailsArray.voucherHistoryVoList
                              )
                              .map((row, index) => (
                                <TableRow key={row.walletId}>
                                  <TableCell align="center">-</TableCell>
                                  <TableCell align="center">{row.timeStamp}</TableCell>
                                  <TableCell align="center">
                                    {row.purchaseAmount}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.refundAmount}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.actionExecutorName}
                                  </TableCell>
                                  <TableCell align="center">{row.remark}</TableCell>
                                  <TableCell align="center">
                                    {row.responseTransactionId}
                                  </TableCell>
                                  <TableCell align="center">
                                    {row.actionExecutorName}
                                  </TableCell>
                                  <TableCell align="center">{row.reason}</TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>
                    )}
                </TableContainer>
              </>)
              :
              ("")} */}

						{/* <TableContainer component={Paper} style={{ marginTop: "15px" }}>
          <Typography
            variant="body1"
            style={{
              textAlign: "center",
              margin: "10px 0",
              color: "#01367e",
              fontSize: "1.4rem",
            }}
          >
            History
          </Typography>

          {getVoucherTransactionDetailsArray &&
            getVoucherTransactionDetailsArray.voucherHistoryVoList && (
              <Table
                className={classes.table}
                aria-label="a dense table"
                style={{ whiteSpace: "nowrap" }}
              >
                <TableHead>
                  <TableRow style={{ background: "#00b9f5" }}>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Action
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      TimeStamp
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Purchase Amount
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Refund Amount
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Currency
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Remark{" "}
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Response Transaction ID
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Action Executor Name
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Reason
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {getVoucherTransactionDetailsArray.voucherHistoryVoList &&
                    []
                      .concat(
                        getVoucherTransactionDetailsArray.voucherHistoryVoList
                      )
                      .map((row, index) => (
                        <TableRow key={row.walletId}>
                          <TableCell align="center">-</TableCell>
                          <TableCell align="center">{row.timeStamp}</TableCell>
                          <TableCell align="center">
                            {row.purchaseAmount}
                          </TableCell>
                          <TableCell align="center">
                            {row.refundAmount}
                          </TableCell>
                          <TableCell align="center">
                            {row.actionExecutorName}
                          </TableCell>
                          <TableCell align="center">{row.remark}</TableCell>
                          <TableCell align="center">
                            {row.responseTransactionId}
                          </TableCell>
                          <TableCell align="center">
                            {row.actionExecutorName}
                          </TableCell>
                          <TableCell align="center">{row.reason}</TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            )}
        </TableContainer> */}
					</Box>
				</div>
			</Layout>
		</>
	);
};

export default GetVoucherTransactionDetails;
